import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { BrowserView, isBrowser, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import users from "../../assets/images/icon_profile/user.svg";
import Config from "../../config/Config";
import { setLoading } from "../../core/feature/config/configSlice";
import { comboStudentsClassViolation, getRewardData, getRewardDataId, getViolationData, getViolationDataId, requestReward, violationImageUpload, violationPointDashboard } from "../../core/service/api_violation_point";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ViolationPointRewardDetailMobile from "./violationPointRewardDetailMobile";
import ViolationPointRewardDetailWeb from "./violationPointRewardDetailWeb";

const ViolationPointRewardDetailComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("ViolationPoint");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const [isScanOpen, setIsScanOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isScan, setIsScan] = useState(false);
  const [students, setStudents] = useState<any>([]);
  const [isToken, setIsToken] = useState<any>(false);
  const { t } = useTranslation();
  const [data, setData] = useState<any>([]);
  const [dataPoint, setDataPoint] = useState<any>({});
  const [studentSelected, setStudentSelected] = useState<any>({});
  const [pagination, setPagination] = useState({
    page: 1,
    size: 10,
    total: 0
  })
  const env = Config.BaseUrlDev;

  const closeModal = () => {
    setIsOpen(false);
    navigate(`/home`, { replace: true });
  };
  const openModal = () => {
    setIsOpen(true);
  };
  const toScanPage = (studentId: string, grade: string) => {
    navigate(`/pickup-student/scan/${studentId}/${grade}`);
  };
  const toQRPage = (studentId: string, grade: string, studentName: string) => {
    navigate(`/pickup-student/create-qr/${studentId}/${grade}/${studentName}`);
  };
  const toBookingPage = () => {
    navigate(`/pickup-student/booking`);
  };
  const toStatusBookingPage = () => {
    navigate("/pickup-student/status");
  };

  const getDashboard = async (studentId: string = '') => {
    try {
      let query: any = [];
      // query.push(`student_id=${studentId}`);
      dispatch(setLoading(true));
      let response = await getRewardDataId(id);
      console.log(response)
      setDataPoint(response.data);
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getComboStudent = async () => {
    try {
      let query = [];
      query.push(`student_class=`);
      dispatch(setLoading(true));
      let response = await comboStudentsClassViolation(query);
      setStudents(response.data);
      const selectStudent = response.data[0]
      localStorage.setItem("selectStudent", JSON.stringify(selectStudent))
      setStudentSelected(selectStudent);
      // getDashboard(selectStudent.id);
    } catch (error) {
    } finally {
      dispatch(setLoading(false));
    }
  };


  const fetchData = async () => {
    try {
      let query: any = [];
      const studentSelect: any = localStorage.getItem("selectStudent")
        ? JSON.parse(localStorage.getItem("selectStudent") as string)
        : {};
      query.push(`student_id=${studentSelect.id}`);
      dispatch(setLoading(true));
      let res = await getViolationData(query);
      setData(res.data.items);
      setStudentSelected(studentSelect)
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(setLoading(false));
    }
  };

  const changeStudent = (value: any) => {
    setStudentSelected(value);
    setIsOpen(false);
    localStorage.setItem("selectStudent", JSON.stringify(value))
  };

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_base/image/get/" + photo + "/pas";
  };

  const saveData = async (data: any) => {
    try {
      dispatch(setLoading(true));
      if (data.photoUrl) {
        const resImage = await violationImageUpload(data.studentId, data.photoUrl)
        data.photoUrl = resImage.data.imgUrl
      } else data.photoUrl = ""
      let newData = {
        rewardMasterId: data.masterRewardId,
        date: data.date,
        description: data.description,
        photoUrl: data.photoUrl
      }
      await requestReward(data.studentId, newData)
    } catch (error) {
    } finally {
      dispatch(setLoading(false));
    }
  }


  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Point Pelanggaran",
    });
    const studentSelect: any = localStorage.getItem("selectStudent")
      ? JSON.parse(localStorage.getItem("selectStudent") as string)
      : {};
    setStudentSelected(studentSelect)
    getComboStudent()
    fetchData()
    getDashboard()
  }, []);
  return (
    <>
      <BrowserView>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      <div className="flex flex-row">
                        {/* <img
                          src={helpIcon}
                          alt=""
                          className="text-black mr-2"
                        /> */}
                        {/* <div>{t("DIGITALCARD.help")}</div> */}
                      </div>
                    </Dialog.Title>
                    <div className="rounded-2xl bg-psp-primary mt-3 p-2">
                      Mohon maaf, Fitur ini belum tersedia pada perangkat
                      desktop
                    </div>
                    <div>
                      <button
                        type="button"
                        className="w-full h-10 ml-1 rounded-md text-white bg-psp-btn-primary"
                        onClick={closeModal}
                      >
                        {t("OTHER.back")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
        <ViolationPointRewardDetailWeb
          toScanPage={toScanPage}
          toBookingPage={toBookingPage}
          toQRPage={toQRPage}
          toStatusBookingPage={toStatusBookingPage}
        ></ViolationPointRewardDetailWeb>
      </BrowserView>
      <MobileView>
        <ViolationPointRewardDetailMobile
          key={`${JSON.stringify(data).length}-${JSON.stringify(students).length}-${JSON.stringify(studentSelected).length}-${JSON.stringify(dataPoint).length}`}
          getProfileImage={(e: string) => getProfileImage(e)}
          changeStudent={(e: any) => changeStudent(e)}
          studentSelect={studentSelected}
          students={students}
          data={data}
          dataPoint={dataPoint}
          saveData={(data: any) => saveData(data)}
        ></ViolationPointRewardDetailMobile>
      </MobileView>
    </>
  );
};

export default ViolationPointRewardDetailComponent;
